export default __webpack_public_path__ + "87ef44ce097e0216fa0f0677b985ab55.coffee";